
import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import React from "react";
import Table from '../../../../../../../../common/components/table-manager/v1.1/table';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../../../redux/library/selector';
import PageLoader from '../../../../../../../../components/PageLoader';
import { ListCriteria } from '../../../../../../../types/list-criteria';
import { planTemplates } from '../../../../../../../../redux/plan-templates/action';
import { selectPlanTemplatesListItems } from '../../../../../../../../redux/plan-templates/selector';

export const EmailTemplateListComponent = React.memo(({

  selectedCollection,
  closeModal,
  handleSubmitData
}: any) => {

  const libraryData = useSelector(selectListItems)

  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const skipNextEffect = useRef(false);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState<any>([]);
  const currentEntityRef = useRef<any>([]);

  const itemsData = useSelector(selectPlanTemplatesListItems)

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Template Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'TemplateTypeId', headerName: 'Template Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.TemplateType } },

    ]);
  }


  const listTemplates = async ({
    pageNumber,
    pageSize,
  }, {
    searchCriteria,
    filterCriteria,
    dateCriteria
  }: ListCriteria) => {
    await dispatch(planTemplates.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/list`,
      entity: 'planTemplates',
      jsonData: {
        "Filters": [
          {
            "FieldName": "TemplateTypeId",
            "FilterOperatorId": 1,
            "FieldValue": 30,
            "FieldType": "number"
          }
        ],
        "PageNumber": pageNumber,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria || undefined,
        "FilterFilters": filterCriteria || undefined,
        "DateCriteria": dateCriteria || undefined
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    skipNextEffect.current = true;

    setPageData(1);
    setPageSize(10);
    listTemplates({ pageNumber: 1, pageSize: 10 }, {});
  }

  const handleSearch = (data: any) => {
    let searchCriteria = [];
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    listTemplates({ pageNumber: pageData, pageSize: pageSize }, { searchCriteria: searchCriteria })
  }

  const handleSelect = useCallback((selectedRows) => {

    currentEntityRef.current = _.map(selectedRows, (item: any) => {
      return {
        "Id": item?.Id,
        "Name": item?.Name,
        "TemplateTypeId": item?.TemplateTypeId,

      }
    })


  }, []);


  useEffect(() => {
    const ids = _.map(selectedCollection?.MediaMappings?.Templates, (template: any) => {
      return template?.MarketingTemplateId
    })
    setDefaultSelectedIds(ids);
  }, [selectedCollection]);

  useEffect(() => {
    createColumnDefs();
  }, []);

  useEffect(() => {
    if (skipNextEffect.current) {
      skipNextEffect.current = false;
      return;
    }

  }, [pageData, pageSize]);

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> : <></>}
      <Table
        columnData={columnDefs}
        rowData={itemsData?.result?.items}
        setPageData={setPageData}
        setPageSize={setPageSize}
        enableFilter={true}
        onSearch={handleSearch}
        onSelect={handleSelect}
        paginationData={itemsData?.result?.pagination}
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: defaultSelectedIds,
          isDisabled: false,
          keyColumn: 'MarketingTemplateId',
        }}
        additionButtons={additionButtons}
        headingName="Email Templates"
      />
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={closeModal}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Close
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={() => handleSubmitData(currentEntityRef.current)}

          type="submit"
        >
          Submit
        </button>
      </div>
    </>
  )
})

export default EmailTemplateListComponent;
